exports.default = {
  // 側邊欄導航
  'general': '通用',
  'domains': '域名',
  
  // 通用設置面板
  'current_version': '當前版本：{version}',
  'open_website': '打開網站',
  'publish_and_access': '發布與訪問',
  'domain': '域名',
  'custom_domain': '自定義域名',
  'your_website_not_online': '您的網站尚未正式上線，僅通過預覽鏈接供您訪問。',
  'status': '狀態',
  'online': '已上線',
  'publishing': '上線中',
  'not_published': '未發布',
  'publish': '發布',
  'unpublish': '取消發布',
  
  // 域名設置面板
  'copy': '複製',
  'not_generated_link': '尚未生成鏈接',
  'custom_domain_with_icon': '自定義域名',
  'keep_subscription_valid': '為確保您的自定義域名保持可訪問狀態，請保持訂閱有效。一旦訂閱過期，該域名可能無法再訪問網站。',
  'connect_existing_domain': '連接現有域名',
  'if_you_have_existing_domain': '如果您已有域名，可以在此連接',
  'connect_domain': '連接域名',
  'loading': '加載中...',
  'no_more': '沒有更多了',
  
  // 域名狀態 - 已驗證
  'connected': '已連接',
  'disconnect': '斷開連接',
  
  // 域名狀態 - 已失效/已過期
  'invalid': '已失效',
  'expired': '已過期',
  'reconnect': '重新連接',
  'reconfigure': '重新配置',
  
  // 域名狀態 - 待驗證
  'pending_verification': '待驗證',
  'please_complete_configuration': '請完成配置。剩餘時間：',
  'time_remaining': '剩餘時間：{time}',
  'check_again': '再次檢查',
  'use_a_record': '使用 A 記錄配置',
  'use_cname_record': '使用 CNAME 配置',
  'record_type': '記錄類型',
  'record_name': '記錄名稱',
  'value': '值',
  'empty_or_at': '空 或',
  'no_corresponding_records': '暫無對應類型的記錄信息',
  'configuration': '配置',
  'unknown': '未知',
  
  // DNS 配置說明
  'how_to_configure': '如何配置',
  'use_a_record_to_point': '使用 "{name}" 將您的域名指向以下 IP 地址：{ip_address}',
  'use_cname_to_apply_to_root_domain': '使用 "{name}" 將 CNAME 應用到您的根域名',
  'dns_propagation_notice': '注意：添加 DNS 記錄後，變更可能需要一些時間才能完全傳播到整個互聯網。',
  
  // 連接域名彈窗
  'connect_domain_dialog_title': '連接域名 ',
  'external_domain': '外部域名',
  'if_you_have_domain_from_other_platform': '如果您已經在其他平台擁有一個域名，可以在此連接。',
  'please_enter_domain': '請輸入域名',
  'bind_both_domain_and_www': '同時設置 {domain} 和 www.{domain}',
  'recommended': '推薦',
  'cancel': '取消',
  'confirm_connect': '確認連接',
  
  // 域名衝突提示彈窗
  'domain_bind_notice': '域名綁定提示',
  'following_domains_used_by_your_other_projects': '以下域名已被您的其他項目使用：',
  'you_can_rebind_to_current_project': '您可以將其換綁到當前項目',
  'rebind_now': '繼續換綁',
  'following_domains_bound_by_other_users': '以下域名已被其他用戶綁定，無法操作：',
  'already_occupied': '已被佔用',
  'close': '關閉',
  
  // 消息提示
  'copied_to_clipboard': '已複製到剪貼板',
  'website_published_successfully': '網站已成功發布上線',
  'unpublished': '已取消發布',
  'network_or_server_error': '網絡或服務器異常，綁定失敗',
  'reconnect_request_failed': '重新連接請求失敗',
  'bind_success': '綁定成功',
  'domain_already_bound_by_other_user': '域名 {domain} 已被其他用戶綁定',
  'partial_bind_success': '部分域名綁定成功：{domains}',
  'bind_failed': '綁定失敗',
  'rebind_success': '域名 {domain} 換綁成功',
  'rebind_request_error': '換綁請求異常',
  'disconnected': '已斷開 {domain} 的連接',
  'disconnect_failed': '斷開連接失敗',
  'dns_verification_passed': '域名 {domain} DNS 驗證通過',
  'dns_verification_failed': 'DNS 驗證未通過，請檢查配置是否正確',
  'check_dns_failed': '檢查 DNS 失敗',
  'invalid_domain_format': '請輸入正確的域名格式',
  
  // WebPreviewPanel 新增
  'settings': '設置',
  'publish': '發布',
  'public_url': '公共 URL',
  'link_not_generated': '尚未生成鏈接',
  'add_custom_domain': '自定義域名',
  'unknown_version': '未知版本',
  'version_prefix': 'V{version}'
}
